import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-weight"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", { class: "" }, [
      _createElementVNode("path", {
        d: "M23.7,15.4c0-0.9-0.7-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.7,1.7,1.7,1.7\n\t\tC22.9,17.1,23.7,16.3,23.7,15.4z",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("polygon", {
        points: "32.3,30.3 11.7,30.3 15,17.2 29,17.2 \t",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }